import { FormTextInput } from '@components/form';

export const McpServerDescriptionField = ({ name }: { name: string }) => {
  return (
    <FormTextInput
      label="Description (optional)"
      name={name}
      placeholder="Brief description of what this MCP server does"
      multiline
      rows={3}
      sx={{ mb: 1.5 }}
    />
  );
};
